import { useEffect, useState } from 'react';
import { ArrowUp } from '../icons/ArrowUp';

export default function BackToTop({ scrollReference }) {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [enableButton, setEnableButton] = useState(false);

  const updateScrollPosition = (e) => {
    setScrollPosition(window.scrollY);
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', updateScrollPosition);
    return () => {
      window.removeEventListener('scroll', updateScrollPosition);
    };
  }, []);

  useEffect(() => {
    setEnableButton(scrollPosition >= scrollReference.current.clientHeight);
  }, [scrollPosition]);

  return (
    <div
      className={`fixed right-5 ${
        enableButton
          ? 'pointer-events-all top-52 opacity-100'
          : 'pointer-events-none top-12  opacity-0'
      } z-10 hidden lg:flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-black bg-black transition-all duration-300 ease-in-out`}
      onClick={scrollTop}
      aria-hidden
      tabIndex="-1"
    >
      <ArrowUp className="text-white" />
    </div>
  );
}
